import { trackingApi } from "../api";

const EVENTS = {
  START_CLAIM_CHECK: "Started CC",
};

export async function trackStart() {
  if (sessionStorage.getItem("sessionAlreadyTracked")) return;

  return trackingApi.registerEvent(EVENTS.START_CLAIM_CHECK).then(() => {
    sessionStorage.setItem("sessionAlreadyTracked", true);
  });
}
